import client from "../client/client";

class CategoryService {
	getTreeForProject({ projectId, search = "", details = true }, cancelToken) {
		return client.get(`/thematic/project/${projectId}`, {
			params: { search, details },
			config: { cancelToken },
		});
	}

	getTreeParentsForProject({ projectId, details = true }, cancelToken) {
		return client.get(`/thematic/project/${projectId}/parents`, {
			params: { details },
			config: { cancelToken },
		});
	}

	getTreeParentsForWithFilters({ projectId }, { filters }, cancelToken) {
		return client.post(`/thematic/project/${projectId}/details`, {
			payload: filters,
			config: { cancelToken },
		});
	}

	getTreeChildrenForProject({ parentId, details = true }, cancelToken) {
		return client.get(`/thematic/${parentId}/children`, {
			params: { details },
			config: { cancelToken },
		});
	}

	getAllChildrenOfParentForProject({ parentId }, cancelToken) {
		return client.get(`/thematic/${parentId}/children/all`, {
			config: { cancelToken },
		});
	}

	getCountOfAllTreeForProject({ projectId }, cancelToken) {
		return client.get(`/thematic/project/${projectId}/count`, {
			config: { cancelToken },
		});
	}

	getByInformation({ informationId }, { search }, cancelToken) {
		return client.get(`thematic/information/${informationId}`, {
			params: { search },
			config: { cancelToken },
		});
	}

	getByDeliverable({ projectId, deliverableId }, { search }, cancelToken) {
		return client.get(`/thematic/project/${projectId}/deliverable/${deliverableId}`, {
			params: { search },
			config: { cancelToken },
		});
	}

	patchByInformation({ informationId }, payload, cancelToken) {
		return client.patch(`thematic/information/${informationId}`, {
			payload,
			config: { cancelToken },
		});
	}

	createFastTrackAutomation({ projectId }, payload, cancelToken) {
		return client.post(`/thematic/project/${projectId}`, { payload, config: { cancelToken } });
	}

	getThematicAutomations({ thematicId }, cancelToken) {
		return client.get(`/thematic/${thematicId}`, { config: { cancelToken } });
	}

	updateFastTrackAutomation({ thematicId }, payload, cancelToken) {
		return client.patch(`/thematic/${thematicId}`, { payload, config: { cancelToken } });
	}

	patchProjectTreeUpdate({ projectId }, payload, cancelToken) {
		return client.patch(`/thematic/project/${projectId}`, { payload, config: { cancelToken } });
	}

	getRoots({ projectId }, cancelToken) {
		return client.get(`thematic/project/${projectId}/rootTypes`, { config: { cancelToken } });
	}

	export({ projectId }, cancelToken) {
		return client.download(`/thematic/project/${projectId}/export`, {
			config: { cancelToken },
		});
	}

	import({ projectId }, { file }, cancelToken) {
		return client.upload(`/thematic/project/${projectId}/import`, file, {
			config: { cancelToken },
		});
	}

	transferAllProjectThematics({ projectId }, cancelToken) {
		return client.post(`/thematic/project/${projectId}/transfer`, {
			config: { cancelToken },
		});
	}

	transferProjectThematicSelection({ thematicList }, cancelToken) {
		return client.post("/thematic/transfer", {
			payload: thematicList,
			config: { cancelToken },
		});
	}

	getAllIds({ projectId }, cancelToken) {
		return client.get(`/thematic/project/${projectId}/all`, { config: { cancelToken } });
	}

	countSelectionForParent({ projectId }, { values }, cancelToken) {
		return client.post(`/thematic/project/${projectId}/counter`, {
			payload: { values },
			config: { cancelToken },
		});
	}

	getAttachedCategoryIdsByInformation({ informationId }, cancelToken) {
		return client.get(`/thematic/information/${informationId}/attached`, { config: { cancelToken } });
	}

	launchCategorizationAgent({ thematicId }, cancelToken) {
		return client.get(`/thematic/${thematicId}/agent`, { config: { cancelToken } });
	}

	rollbackCategorizationAgentResults({ projectId, agentExecutionId }, cancelToken) {
		return client.get(`/thematic/project/${projectId}/agent-execution/${agentExecutionId}/rollback`, {
			config: { cancelToken },
		});
	}

	getCategorizationAgentConfig({ thematicId }, cancelToken) {
		return client.get(`/thematic/${thematicId}/ai-config`, { config: { cancelToken } });
	}

	saveCategorizationAgentConfig(
		{ thematicId },
		{ integrationPolicy, documents, additionPrompt, selectDocumentAutomatically },
		cancelToken
	) {
		return client.post(`/thematic/${thematicId}/ai-config`, {
			payload: {
				integrationPolicy,
				documents,
				additionPrompt,
				selectDocumentAutomatically,
			},
			config: { cancelToken },
		});
	}

	getCategorizationLaunchHistory({ thematicId }, cancelToken) {
		return client.get(`/thematic/${thematicId}/agent-history`, { config: { cancelToken } });
	}

	launchGlobalCategorizationAgent({ projectId }, cancelToken) {
		return client.get(`/thematic/project/${projectId}/agent`, { config: { cancelToken } });
	}

	getActiveCategorizations({ projectId }, cancelToken) {
		return client.get(`/thematic/project/${projectId}/running-agent`, { config: { cancelToken } });
	}

	launchCategoryTreeCreation({ projectId }, cancelToken) {
		return client.get(`/thematic/tree/projects/${projectId}/agent`, { config: { cancelToken } });
	}

	getTreeCreationAgentConfig({ projectId }, cancelToken) {
		return client.get(`/thematic/tree/projects/${projectId}/ai-config`, { config: { cancelToken } });
	}

	saveTreeCreationAgentConfig(
		{ projectId },
		{ integrationPolicy, documents, additionPrompt, selectDocumentAutomatically },
		cancelToken
	) {
		return client.post(`/thematic/tree/projects/${projectId}/ai-config`, {
			payload: {
				integrationPolicy,
				documents,
				additionPrompt,
				selectDocumentAutomatically,
			},
			config: { cancelToken },
		});
	}

	getTreeCreationAgentHistory({ projectId }, cancelToken) {
		return client.get(`/thematic/tree/projects/${projectId}/history`, { config: { cancelToken } });
	}

	getThematicInformation({ thematicId }, cancelToken) {
		return client.get(`/thematic/${thematicId}/self`, { params: { details: true }, config: { cancelToken } });
	}
}
export default new CategoryService();
